export const CDN_URL =
  "https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_660";
export const LOGO_URL =
  "https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto/portal/static-assets/images/swiggy_logo_white.png";

export const API_URL = "https://www.swiggy.com/dapi";
export const NAMASTE_DEV_BACKEND_URL = "https://namastedev.com/api/v1";
export const GIT_HUB_URL = "https://api.github.com/users/abiek12";
export const DEFAULT_USER = {
  name: "Guest",
  email: "guest@gmail.com",
};
